import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setAssignedBuildings,
  setBuildingOptions,
  updateBuildingInState,
  addBuildingToState,
  removeBuildingFromState,
} from "../../../../../redux/customers/customerBuildingSlice";
import {
  fetchAllBuildings,
  fetchAssignedBuildings,
  addBuilding,
  removeBuilding,
  updateBuilding,
  createNewBuilding,
} from "../services/customerBuildingService";

export const useCustomerBuildings = (customerID) => {
  const dispatch = useDispatch();
  const { assignedBuildings, buildingOptions } = useSelector(
    (state) => state.customerBuildings
  );

  const loadBuildingOptions = useCallback(async () => {
    try {
      const options = await fetchAllBuildings();
      dispatch(setBuildingOptions(options));
    } catch (error) {
      console.error("Error loading building options:", error);
    }
  }, [dispatch]);

  const loadAssignedBuildings = useCallback(async () => {
    if (customerID) {
      try {
        const buildings = await fetchAssignedBuildings(customerID);
        dispatch(setAssignedBuildings(buildings));
      } catch (error) {
        console.error("Error loading assigned buildings:", error);
      }
    }
  }, [customerID, dispatch]);

  const addBuildingToCustomer = useCallback(
    async (buildingID) => {
      if (customerID && buildingID) {
        try {
          const newBuilding = await addBuilding(customerID, buildingID);
          dispatch(addBuildingToState(newBuilding));
        } catch (error) {
          console.error("Error adding building:", error);
        }
      }
    },
    [customerID, dispatch]
  );

  const removeBuildingFromCustomer = useCallback(
    async (buildingID) => {
      if (customerID && buildingID) {
        try {
          await removeBuilding(customerID, buildingID);
          dispatch(removeBuildingFromState(buildingID));
        } catch (error) {
          console.error("Error removing building:", error);
        }
      }
    },
    [customerID, dispatch]
  );

  const updateBuildingData = useCallback(
    async (buildingID, buildingData) => {
      try {
        const updated = await updateBuilding(buildingID, buildingData);
        dispatch(updateBuildingInState(updated));
      } catch (error) {
        console.error("Error updating building:", error);
      }
    },
    [dispatch]
  );

  const createNewBuildingInCustomer = useCallback(async (buildingData) => {
    try {
      const created = await createNewBuilding(buildingData);
      // Optionally dispatch if you need to update buildingOptions or assignedBuildings.
      return created;
    } catch (error) {
      console.error("Error creating new building:", error);
    }
  }, []);

  return {
    assignedBuildings,
    buildingOptions,
    loadBuildingOptions,
    loadAssignedBuildings,
    addBuildingToCustomer,
    removeBuildingFromCustomer,
    updateBuildingData,
    createNewBuildingInCustomer,
  };
};
